<template>
  <div>
    <b-breadcrumb :items="navigationItems" />
    <b-container>
      <b-row>
        <b-col cols="12">
          <h2>Search</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-tabs content-class="mt-3">
            <b-tab title="Configuration Search">
              <search id="search" />
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import search from '../UIComponents/Search'

export default {
  components: {
    search
  },
  data() {
    return {
      navigationItems: [{
        text: 'Home',
        to: { name: 'home' }
      }, {
        text: 'Payments',
        to: { name: 'client' }
      }, {
        text: 'Search',
        active: true
      }]
    }
  }
}
</script>
